// @flow
import get from 'lodash/get';
import type { SearchNotification, SubscriptionResponse } from '../types';
import getQueryMapperByVerticalId from '../../../shared/SearchNotifications/adapters/subscriptionQueryMapper/getQueryMapperByVerticalId';

function mapSearchNotifications(
  verticalId: number,
  response: Object
): Array<SearchNotification<*>> {
  const apiSearchNotifications = get(response, 'included', []);

  return apiSearchNotifications.map(apiSearchNotification => {
    const mapQuery = getQueryMapperByVerticalId(verticalId);

    return {
      id: apiSearchNotification.id,
      active: get(apiSearchNotification, 'attributes.active', false),
      query: mapQuery(apiSearchNotification),
      changed: false,
    };
  });
}

export default function map(verticalId: number, response: Object): SubscriptionResponse<*> {
  return {
    searchNotifications: mapSearchNotifications(verticalId, response),
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/SearchNotifications/adapters/subscriptionResponse.js